<template>
    <div class="certificate__signature" :style="{ textAlign: align }">
        <div class="certificate__signature-image">
            <img v-if="imageUrl" :src="imageUrl" alt="" />
        </div>
        <div class="certificate__signature-line"></div>
        <div class="certificate__signature-name" :style="nameStyle">{{ signatory.name }}</div>
        <div v-if="signatory.role" class="certificate__signature-role" :style="roleStyle">{{ signatory.role }}</div>
    </div>
</template>

<script>
/**
 * Bloco de assinatura no certificado do aluno (backlog#344): imagem, linha,
 * nome e cargo do signatário (valor resolvido na emissão).
 */
export default {
    name: 'CertificateInputSignature',

    props: { id: String, data: Object },

    computed: {
        signatory() { return (this.data.value && typeof this.data.value === 'object' ? this.data.value : this.data.signatory) || {}; },
        imageUrl() {
            const s = this.signatory;
            if (s.image) return s.image;
            if (s.upload && s.upload.urls) return s.upload.urls.lg || s.upload.urls.original;
            return null;
        },
        styleText() { return this.data.styleText || {}; },
        align() { return this.styleText.alignText || 'center'; },
        nameStyle() {
            return { fontSize: this.styleText.letterSize ? `${this.styleText.letterSize}px` : '13px', color: this.styleText.textColor || '#111', fontFamily: this.styleText.fontFamily || 'Roboto', fontWeight: 'bold', fontVariantLigatures: 'none' };
        },
        roleStyle() {
            return { fontSize: this.styleText.letterSize ? `${Math.max(8, this.styleText.letterSize - 3)}px` : '11px', color: this.styleText.textColor || '#444', fontFamily: this.styleText.fontFamily || 'Roboto', fontVariantLigatures: 'none' };
        },
    },
};
</script>

<style scoped>
.certificate__signature { position: relative; width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: flex-end; padding: 2px 6px; }
.certificate__signature-image { flex: 1; min-height: 20px; display: flex; align-items: flex-end; justify-content: center; }
.certificate__signature-image img { max-height: 100%; max-width: 100%; object-fit: contain; }
.certificate__signature-line { border-top: 1px solid #333; margin: 2px 0; }
.certificate__signature-name, .certificate__signature-role { line-height: 1.2; }
</style>
